import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=a24f9510&"
import script from "./filters.vue?vue&type=script&lang=js&"
export * from "./filters.vue?vue&type=script&lang=js&"
import style0 from "./filters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a24f9510')) {
      api.createRecord('a24f9510', component.options)
    } else {
      api.reload('a24f9510', component.options)
    }
    module.hot.accept("./filters.vue?vue&type=template&id=a24f9510&", function () {
      api.rerender('a24f9510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/filters/filters.vue"
export default component.exports